import { FormControl, NG_VALIDATORS } from '@angular/forms';
import { Directive, Input } from '@angular/core';

@Directive({
    selector: '[floRequiredIf]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: RequiredIfDirective, multi: true },
    ],
})
export class RequiredIfDirective {
    private formControl: FormControl;
    private _floRequiredIf: boolean;

    @Input()
    set floRequiredIf(value: boolean) {
        if (this.formControl &&
            this._floRequiredIf !== value) {
            // If the value is changing force a validation check
            this._floRequiredIf = value;
            this.formControl.updateValueAndValidity();
        } else {
            this._floRequiredIf = value;
        }
    }

    get floRequiredIf(): boolean {
        return this._floRequiredIf;
    }

    public validate(control: FormControl): { [s: string]: boolean } {
        this.formControl = control;

        if (this.floRequiredIf === true &&
            !control.value &&
            control.value !== 0
        ) {
            return { invalid: true };
        }

        return null;
    }
}
